/* eslint-disable @typescript-eslint/camelcase */
import { NotificationType } from '../index'
import bookingImport from './types/bookingImport'
import iCalImport from './types/iCalImport'
import bookingSync from './types/bookingSync'
import notificationError from './types/notificationError'
import iCalUrlIssue from './types/iCalUrlIssue'
import iCalExport from './types/iCalExport'
import notificationLicense from './types/notificationLicense'
import airbnbImport from './types/airbnbImport'

export default function(item) {
  return {
    action: item.data.action,
    actionClasses: item.data.actionClasses,
    actionLabel: item.data.actionLabel,
    createdAt: parseItemDate(item.created_at),
    data: item.data.data,
    deletedAt: parseItemDate(item.deleted_at),
    details: mapNotificationDetails(item.data, item.type),
    gui_notification_id: item.gui_notification_id, //date
    id: item.id,
    licenseFinishDate: parseItemDate(item.data.licenseFinishDate),
    message: item.data.message,
    readAt: parseItemDate(item.read_at),
    seenAt: parseItemDate(item.seen_at),
    status: item.status,
    subtitle: item.data.subtitle,
    booking_property_id:
      item.data.property ||
      item.data.oldProperty ||
      (item.data.data && item.data.data.property),
    title: item.data.title,
    type: item.type,
    updatedAt: parseItemDate(item.updated_at),
  }
}

export function parseItemDate(item) {
  return item ? new Date(Number(item) * 1000) : undefined
}

function mapNotificationDetails(data, type) {
  switch (type as NotificationType) {
    case NotificationType.BookingImport:
      return bookingImport(data)
    case NotificationType.ICalImport:
      return iCalImport(data)
    case NotificationType.BookingSynchronization:
      return bookingSync(data)
    case NotificationType.NotificationError:
      return notificationError(data)
    case NotificationType.ICalUrlIssue:
      return iCalUrlIssue(data)
    case NotificationType.ICalExport:
      return iCalExport(data)
    case NotificationType.ICalLicenseExtended:
      return notificationLicense(data)
    case NotificationType.ICalLicenseRenewed:
      return notificationLicense(data)
    case NotificationType.BookingLicenseExtended:
      return notificationLicense(data)
    case NotificationType.AirbnbImport:
      return airbnbImport(data)
    default:
      return {}
  }
}
